import React, { Component } from 'react';
//import PropTypes from 'prop-types';
//import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'

class ItemView extends Component {

  render() {

    return (
      <li>
        <Link className="flag" to={`/item/${this.props.item.get("id")}`}>
          <div className="flag-object">
            <img className="item-queue-img" src={this.props.item.get("box_image_url")} alt="" />
          </div>
          <div className="flag-body item-queue-content">
            <div className="item-queue-name">{this.props.item.get("name")}</div>
            <div className="item-queue-id">{this.props.item.get("id")}</div>
          </div>
        </Link>
      </li>
    )

  }
}

// WelcomeView.propTypes = {
//   current_user_id: PropTypes.number
// };

export default ItemView;



// WEBPACK FOOTER //
// ./src/snapit_app/components/ItemView.js